import React from "react"
import NoContent from "components/elements/NoContent"

const TemplateUnavailable = () => (
  <NoContent
    title="Template Unavailable"
    descriptionItems={[
      "This WhatsApp template is no longer available. It may have been removed or updated.",
    ]}
  />
)

export default TemplateUnavailable
